import React from "react";
import { TypographyProps, Typography, Box, BoxProps } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export interface ErrorMessageProps {
  error?: string;
  boxProps?: Partial<BoxProps>;
  typographyProps?: Partial<TypographyProps>;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  typographyProps = {},
  boxProps = {},
}) => {
  const styles = useStyles();
  return (
    <>
      {error !== undefined && (
        <Box display="flex" flexDirection="row" {...boxProps}>
          <Typography className={styles.error} {...typographyProps}>
            {error}
          </Typography>
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles(() => ({
  error: {
    color: "#bb1717",
  },
}));

export { ErrorMessage };
